import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserInfoService } from 'src/app/shared/UserInfo/user-info.service';
import { logout } from 'src/app/core/auth/store/actions/auth.action';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  userInfo: any;
  isExpanded = false;

  constructor(private userInfoService: UserInfoService, private store: Store) {}

 

  logout() {
    this.store.dispatch(logout());
  }
 
  toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }
}



